export interface AgencyTagFilter {
  tags: Array<string>;
  matchAny: (tags?: Array<string> | null) => boolean;
}

const tagMatchesFilter = (tag: string, filterTag: string): boolean => {
  const tagSegments = tag.split(".");
  const filterTagSegments = filterTag.split(".");
  return filterTagSegments.every(
    (filterTagSegment, index) =>
      index < tagSegments.length && filterTagSegment === tagSegments[index]
  );
};

export const getPrefixFiltersForAgencyTag = (
  agencyTag: string
): Array<string> => {
  const tagSegments = agencyTag.split(".");
  return tagSegments.map((_, index) =>
    tagSegments.slice(0, index + 1).join(".")
  );
};

export const getAgencyTagFilter = (
  filterTags: Array<string>
): AgencyTagFilter => {
  return {
    tags: filterTags,
    matchAny: (tags?: Array<string> | null) => {
      return (
        filterTags.length == 0 ||
        (tags?.some((tag) =>
          filterTags?.some((filterTag) => tagMatchesFilter(tag, filterTag))
        ) ??
          false)
      );
    },
  };
};
